//for cards use https://youtu.be/htGfnF1zN4g
// sceoll element https://youtu.be/T33NN_pPeNI
import greenshop from '../assets/images/greenshop.png'
import youtube from '../assets/images/youtube.png'
import nihol from '../assets/images/Nihol.png'


import LanguageIcon from '@mui/icons-material/Language';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TelegramIcon from '@mui/icons-material/Telegram';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';



import React, { useState } from 'react'
import styled from 'styled-components'
import CTA from './CTA';

const Projects = () => {
  const [toggle1,setToggle1] = useState(false)
  const [toggle2,setToggle2] = useState(false)
  const [toggle3,setToggle3] = useState(false)
  const [toggle4,setToggle4] = useState(false)

  console.log(toggle1);
  return (
    <Portfolio id="portfolio">
    <Container>
    <h3>Portfolio</h3>
      <div  className={`card ${toggle1 ? 'is-flipped' : ''}`} onClick={()=> setToggle1(!toggle1)}  >
        <div  className='card__inner'>
          <CardFace className="card__face card__face--front card__face-greenshop">
            <h2>Greenshop</h2>
            <p> Things I used and learnt from this project
            <ul>
              <li> - Convential commit, _husky</li>
              <li> - Image loading detect  | Skeleton Animation</li>
              <li> - QR Code Based Authentication</li>
              <li> - User Role (Seller & Buyer)</li>
              <li> - Image Upload & Multiple Image Upload</li>
              <li> - Token & access token </li>
              <li> - React best practices</li>
            </ul>
          </p>
          </CardFace>
          <div className="card__face card__face--back">
            <div className="card__content">
              <div className="card__header card__header-greenshop">
              <img className='image' src={greenshop} />
              <a  className='card_url' target='_blank'  href='https://greenshop-tsc.vercel.app/'>Live</a>
              </div>
              <div className="card__body">
                <h3>Description</h3>
                In my ecommerce ReactJS project for selling green plants, I implemented conventional commit, _husky, image loading detection with skeleton animation, QR code authentication, user roles (seller & buyer), image upload with multiple uploads, token management, and adhered to React best practices.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div  className={`card ${toggle2 ? 'is-flipped' : ''}`} onClick={()=> setToggle2(!toggle2)}  >
        <div  className='card__inner'>
          <CardFace className="card__face card__face--front">
            <h2>Nihol</h2>
            <p>Things I used and learnt from this project
            <ul>
              <li>- Authentication</li>
              <li>- Cookie</li>
              <li>- Cache</li>
              <li>- Blob downloading </li>
              <li>- Working with secured API</li>
              <li>- Working with Documentation</li>
              <li>- Multi language </li>
              <li>- Custom hook </li>
              <li>- Better code</li>
            </ul>
           </p>
          </CardFace>
          <div className="card__face card__face--back">
            <div className="card__content">
              <div className="card__header">
              <img className='image' src={nihol} />
              <a className='card_url' target='_blank' href='https://nihol-bice.vercel.app/'>Live</a>
              </div>
            <div className="card__body">
                <h3>Description</h3>
                Impressive! In my ReactJS project for a sanatorium, I incorporated authentication, cookies, caching, blob downloading, secured API interaction, documentation usage, multi-language support, custom hooks, and optimized code for efficient client tracking.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div  className={`card ${toggle3 ? 'is-flipped' : ''}`} onClick={()=> setToggle3(!toggle3)}  >
        <div  className='card__inner'>
          <CardFace className="card__face card__face--front card__face-youtube">
            <h2>YouTube Clone</h2>
            <p> Things I used and learnt from this project
            <ul>
              <li>- Using API</li>
              <li>- Routing</li>
              <li>- Search  </li>
              <li>- Using axios</li>
              <li>- SCSS </li>
              <li>- Custom hook </li>
              <li>- Fetching Data </li>
            </ul>
          </p>
          </CardFace>
          <div className="card__face card__face--back">
            <div className="card__content">
              <div className="card__header card__header-youtube">
              <img className='image' src={youtube} />
              <a  className='card_url' target='_blank'  href='https://youtube-clone-seven-theta.vercel.app/'>Live</a>
              </div>
              <div className="card__body">
                <h3>Description</h3>
                I've developed a ReactJS project, a YouTube clone that allows users to search and explore videos and channels. Built with JavaScript, it offers a seamless experience for discovering and watching content.

               </div>
            </div>
          </div>
        </div>
      </div>
      <CTA />
    </Container>
   </Portfolio>
  )
}
export default Projects
const Container = styled.div`
  margin:0 auto;
  max-width:1240px;
  padding:0 140px;
  @media (max-width: 1040px) {
    padding:0 36px;
  }
  .card {
  margin: 100px auto 0;
  width: 400px;
  height: 600px;
  perspective: 1000px;
}
.card__inner {
width: 100%;
height: 100%;
transition: transform 1s;
transform-style: preserve-3d;
cursor: pointer;
position: relative;
transform: rotateY(0deg);

}

.is-flipped .card__inner {
transform: rotateY(180deg);
}


.card__face {
position: absolute;
width: 100%;
height: 100%;
-webkit-backface-visibility: hidden;
backface-visibility: hidden;
overflow: hidden;
border-radius: 16px;
box-shadow: 0px 3px 18px 3px rgba(0, 0, 0, 0.2);
@media (max-width:900px) {
  height: 80%;
 }
}

.card__face--front {
background-image: linear-gradient(to bottom right, #FFCE00,  #FE4880);
display: flex;
align-items: center;
justify-content: center;
@media (max-width:620px){
  padding: 13px;
}
}
.card__face-greenshop {
background-image: linear-gradient(to bottom right, #46A358,  #B0FC38);
}
.card__face-youtube {
background-image: linear-gradient(to bottom right, red,  #FA8072);
}
.card__face--front h2 {
color: #FFF;
font-size: 32px;
}
 .card__face--back {
background-color:  #F3F3F3;
transform: rotateY(180deg);
}

.card__content {
width: 100%;
height: 100%;
}

.card__header {
position: relative;
padding: 30px 30px 40px;
display: flex;

}
.card_url {
  position: absolute;
  right:20px;
  top: 20px;
}

.card__header:after {
content: '';
display: block;
position: absolute;
top: 0;
left: 0;
right: 0;
bottom: 0;
background-image: linear-gradient(to bottom left, #FFCE00 10%,    #FE4880  115%);
z-index: -1;
border-radius: 0px 0px 50% 0px;
}
.card__header-greenshop:after {
  background-image: linear-gradient(to bottom left, #46A358 10%,   #B0FC38  115%);
}

.card__header-youtube:after {
  background-image: linear-gradient(to bottom left, red 10%,   #FA8072  115%);
}
.pp {
display: block;
width: 128px;
height: 128px;
margin: 0 auto 30px;
border-radius: 50%;
background-color: #FFF;
border: 5px solid #FFF;
object-fit: cover;
}

.card__header h2 {
color: #FFF;
font-size: 32px;
font-weight: 900;
text-transform: uppercase;
text-align: center;
}

.card__body {
padding: 30px;
}

.card__body h3 {
color: #212121;
font-size: 24px;
font-weight: 600;
margin-bottom: 15px;
}

.card__body p {
color: #212121;
font-size: 18px;
line-height: 1.4;
}


`
const CardFace = styled.div`
  display: flex;
  flex-direction: column;
  color: white;

  p {
    font-size:25px;
   }
   span {
    display:inline-block;
    margin-bottom:8px;
   }
   ul {
     text-align:start;
   }
   li {
    list-style:none;
    font-size: 22px;
    font-weight: 600;
   }
   @media (max-width:620px){

    li {
      font-size: 15px;
    }
    p {
      font-size: 17px;
    }
   }

`

const Portfolio = styled.div`
    padding:50px;
    background-color: rgb(221, 224, 224);
    margin:100px 0;
    text-align:center;
    @media (max-width: 730px) {
      padding:50px 16px;

    }
    h3 {
      font-weight:600;
      font-size:30px;
    }
    .card {
      margin:80px 0;
      display:flex;
      width:100%;
      @media (max-width: 830px) {
        flex-direction:column;
      }
      img {
        width:78%;
        @media (max-width: 830px) {
          width:80%
        }
      }
    }
`


      {/* <div className="card">
        <img src={greenshop}/>
        <Des>
          <p> Things I used and learnt from this project
            <ul>
              <li> - Convential commit, _husky</li>
              <li> - Image loading detect  | Skeleton Animation</li>
              <li> - QR Code Based Authentication</li>
              <li> - User Role (Seller & Buyer)</li>
              <li> - Image Upload & Multiple Image Upload</li>
              <li> - Token & access token </li>
              <li> - React best practices</li>
            </ul>
          </p>
          <div className="bottom">
          <ul>
          <span>Used Languages</span>
            <li>
              TypeScript 
            </li>
            <li>
              TailwindCss
            </li> <li>
              ReactJS
            </li>
          </ul>
          <div className="link">
            <a href="https://github.com/NUKUS777/greenshop" target="_blank"><GitHubIcon />GitHub</a>
            <a href="https://greenshop-tsc.vercel.app/" target="_blank"><LanguageIcon /> Demo </a>
          </div>
          </div>
        </Des>
      </div>
      <div className="card">
        <img src={nihol}/>
        <Des>
          
          <div className="bottom">
          <ul>
          <span>Used Languages and Tools</span>
            <li>
              Javascript 
            </li>
            <li>
              Styled-Components
            </li> 
            <li>
              Ant-Desing
            </li>
          </ul>
          <div className="link">
            <a href="https://github.com/NUKUS777/Nihol" target="_blank"><GitHubIcon />GitHub</a>
            <a href="https://nihol-delta.vercel.app/" target="_blank"><LanguageIcon /> Demo </a>
          </div>
          </div>
        </Des>
      </div>
      <div className="card">
        <img src={drill}/>
        <Des>
          <p> Things I used and learnt from this project
            <ul>
              <li> - Responsive Desing</li>
              <li> - Framer motion</li>
              <li> - Firebase Authentication</li>
              <li> - Working with Fake API</li>
              <li> - Token </li>
              <li> - React best practices</li>
            </ul>
          </p>
          <div className="bottom">
          <ul>
          <span>Used Languages</span>
            <li>
              Typescript 
            </li>
            <li>
              SCSS
            </li> <li>
              ReactJs
            </li>
          </ul>
          <div className="link">
            <a href="https://github.com/NUKUS777/Online-Store" target="_blank"><GitHubIcon />GitHub</a>
            <a href="" target="_blank"><LanguageIcon /> Demo </a>
          </div>
          </div>
        </Des>
      </div> */}

// const Des = styled.div`
//    padding:10px;
//    width:230px;
//    display:flex;
//    flex-direction:column;
//    justify-content:space-around;
//    text-align:center;
//    background-color: rgb(204, 204, 204);
//    @media (max-width: 830px) {
//     width:96%;
//     padding: 10px;
//     align-items:center;
//    }
//    .bottom {
//     @media (max-width: 830px) {
//       display:flex;
//       align-items:center;
//       justify-content:space-between;
//       width:100%;
//       height:100px;
//      }
//    }
//    a {
//       display:flex;
//       align-items:center;
//       justify-content:space-between;
//       flex-direction:column;
//       width:40px;
//       height:50px;
//       color:black;
//       transition:all 1s ease;
//       text-decoration:none;
//    }
//    a:hover {
//     color:blue;
//     transform:scale(1.03)
//    }
//    .link {
//     display:flex;
//     justify-content:space-between;
//     width:90px;
//     margin: 0 auto;
//    }

// `
